import { IRouterProps } from '@interfaces/App.interface';
import { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import {
  generateBasicColumn,
  generateDateColumn,
  generateEntityColumn,
  generateGlobalColumns,
  generateNumberColumn,
  IDataGridConfig,
  TInheritedProps,
} from '@ts/storybook';
import { IConfigComponent } from '@ts/ui-models';
import { useMemo } from 'react';

interface ILicensesProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
}

export const defaultConfigComponent: IConfigComponent = generateConfigComponent('license');

const Licenses = (props: ILicensesProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;

  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [
      globalCells.id(),
      generateEntityColumn({ field: 'organization', headerName: 'Organization' }, { field: 'organization' }),
      generateBasicColumn({ field: 'licenseTypeName', headerName: 'License type name' }, { field: 'type.name' }),
      generateNumberColumn({ field: 'value' }, { field: 'value' }),
      generateDateColumn({ field: 'licenseValidStart' }, { field: 'licenseValidStart' }),
      generateDateColumn({ field: 'licenseValidEnd' }, { field: 'licenseValidEnd' }),
      generateNumberColumn({ field: 'actualValue' }, { field: 'actualValue' }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      inheritedProps={inheritedProps}
    />
  );
};

export default Licenses;
